// components/features/support/clients/UpdateClientModal.tsx
import { useState, useEffect } from "react";
import BaseModal from "../../ui/Modal";
import ClientForm, { ClientFormData } from "./ClientForm";

interface UpdateClientModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (clientData: ClientFormData) => void;
  clientData: ClientFormData;
  clientId: string | number;
}

export default function UpdateClientModal({
  isOpen,
  onClose,
  onSuccess,
  clientData,
  clientId,
}: UpdateClientModalProps) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<ClientFormData>(clientData);

  // Mettre à jour les données du formulaire quand le client change
  useEffect(() => {
    if (clientData) {
      setFormData(clientData);
    }
  }, [clientData]);

  const handleSubmit = async (data: ClientFormData) => {
    setLoading(true);
    try {
      // On peut ajouter l'ID du client dans les données si nécessaire
      await onSuccess({ ...data, id: clientId } as any);
      onClose();
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <BaseModal isOpen={isOpen} onClose={onClose} title="Modifier le client">
      <ClientForm
        initialData={formData}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        loading={loading}
        submitLabel="Modifier le client"
        cancelLabel="Annuler"
      />
    </BaseModal>
  );
}